import { PedOverlaySection } from '~/shared';
import hair from '~/assets/icons/hair.svg';
import eyebrows from '~/assets/icons/eyebrows.svg';
import beard from '~/assets/icons/beard.svg';
import bodyHair from '~/assets/icons/body_hair.svg';

export const facialHairSections = [
	PedOverlaySection.Hair,
	PedOverlaySection.Eyebrows,
	PedOverlaySection.FacialHair,
	PedOverlaySection.BodyHair,
];

export const facialHairIcons: Partial<Record<PedOverlaySection, string>> = {
	[PedOverlaySection.Hair]: hair,
	[PedOverlaySection.Eyebrows]: eyebrows,
	[PedOverlaySection.FacialHair]: beard,
	[PedOverlaySection.BodyHair]: bodyHair,
};
